import * as Swiper from "../libs/swiper";

export function testimonialsSlider() {
    this.$window.on("load", function () {
        const slider = $(".testimonials-slider-left");

        const sliderSettings = {
            slidesPerView: 4,
            watchOverflow: true,
            autoHeight: false,
            loop: true,
            centeredSlides: false,
            pagination: {
                el: slider.find(".swiper-pagination"),
                type: "bullets",
                clickable: true
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            breakpoints: {
                1024: {
                    slidesPerView: 2,
                }
            }
        };

        const mySwiper = new Swiper(slider, sliderSettings);

        const slider2 = $(".testimonials-slider-right");

        const sliderSettings2 = {
            slidesPerView: 1,
            watchOverflow: true,
            autoHeight: false,
            loop: true,
            centeredSlides: true,
            fadeEffect: { crossFade: true },
            effect: "fade",
            pagination: {
                el: slider.find(".swiper-pagination"),
                type: "bullets",
                clickable: true
            }
        };

        const mySwiper2 = new Swiper(slider2, sliderSettings2);

        mySwiper.on("slideNextTransitionStart", function() {
            mySwiper2.slideNext();
        });

        mySwiper.on("slidePrevTransitionStart", function() {
            mySwiper2.slidePrev();
        });
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/testimonials-slider.js